import { createRouter, createMemoryHistory, createWebHashHistory } from 'vue-router'
import Step1 from '@/views/Step1.vue'
import Step2Once from '@/views/Step2Once.vue'
import Step2Recurring from '@/views/Step2Recurring.vue'
import Step3 from '@/views/Step3.vue'
import Done from '@/views/Done.vue'


const routes = [
  {
    path: '/',
    name: 'step1',
    component: Step1
  },
  {
    path: '/step2',
    name: 'step2_once',
    component: Step2Once
  },
  {
    path: '/step2',
    name: 'step2_recurring',
    component: Step2Recurring
  },
  {
    path: '/step3',
    name: 'step3',
    component: Step3
  },
  {
    path: '/done',
    name: 'done',
    component: Done
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
